import styled from 'styled-components';
import { POPPINS_FAMILY } from 'styles/poppins_font';

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 682px;
  /* O selo de confirmação fica metade para fora do cartão. */
  margin: 49px auto 0;
  padding: 84px 39px 44px;
  border-radius: 34px;
  background: ${(props) => props.theme.$white};
  color: ${(props) => props.theme.$black};
  font-family: ${POPPINS_FAMILY};
  text-align: center;

  .welcome-check {
    position: absolute;
    top: -49px;
    left: 50%;
    transform: translateX(-50%);
  }

  .welcome-title {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 9px;
    margin: 0;
    font-size: 26px;
    font-weight: 700;
    line-height: normal;

    img {
      flex-shrink: 0;
    }
  }

  .sparkle-mirrored {
    transform: scaleX(-1);
  }

  .welcome-subtitle {
    margin: 9px 0 0;
    font-size: 20px;
    font-weight: 500;
    line-height: normal;
  }

  .welcome-text {
    max-width: 602px;
    margin: 17px 0 0;
    font-size: 18px;
    font-weight: 400;
    line-height: normal;
  }

  .welcome-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    width: 324px;
    max-width: 100%;
    height: 50px;
    margin-top: 45px;
    border: 0;
    border-radius: 80px;
    background: #11b37d;
    color: ${(props) => props.theme.$white};
    font-family: ${POPPINS_FAMILY};
    font-size: 18px;
    font-weight: 700;
    line-height: normal;
    text-decoration: none;
    text-transform: uppercase;
    transition: filter 0.15s ease;

    &:hover,
    &:focus {
      color: ${(props) => props.theme.$white};
      filter: brightness(1.08);
    }
  }

  @media only screen and (max-width: 768px) {
    padding: 72px 20px 32px;

    .welcome-title {
      font-size: 20px;
    }

    .welcome-subtitle {
      font-size: 17px;
    }

    .welcome-text {
      font-size: 15px;
    }

    .welcome-button {
      font-size: 15px;
    }
  }
`;
